window.getEnvironment = function getEnvironment() {
  const environments = {
    'app.zeroni.fi': 'PRODUCTION',
    'sitemanager.takamaki.fi': 'PRODUCTION',
    'dev.zeroni.fi': 'TEST',
    'staging.zeroni.fi': 'STAGING',
  };
  return environments[window.location.hostname] || 'DEVELOPMENT';
};


window.getCookieValue = getCookieValue;
window.currentUserId = getCookieValue('currentUserId');
window.currentDomainId = getCookieValue('currentCompanyId');

function getCookieValue(a) {
  var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}

